import { Component, Prop, Ref, SimpleEvent, log } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';


import "./ProductContentCta.scss"

@Component
export class ProductContentCta extends ThemeComponent {

}
